export const skillsStack = [
  "React",
  "TypeScript",
  "JavaScript",
  "Next.js",
  "Tailwind",
  "React Native",
  "HTML5",
  "CSS3",
  "npm",
  "Git",
  "Bootstrap",
  "Context API",
  "React Router",
  "Axios",
  "Styled Components",
  "Material UI",
  "Redux",
  "SQL",
];
